module.exports = __webpack_public_path__ + "img/66.366c1492.jpg";